import type { Observable } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type { StoreComplaint } from '@domain/models/store.model';

export abstract class StoreComplaintRepository {
  abstract list(query: PageQuery): Observable<PagedResult<StoreComplaint>>;
}
